import React, { useEffect, useState, useRef } from 'react';
import {
  AiOutlinePlusCircle,
  AiOutlineDelete,
  AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { useLoading } from '../../../context/LoadingContext';
import { CiEdit } from "react-icons/ci";
import ToastNotification from '../../../components/ToastNotification';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import socket from "../../../socket";

function ServiceSchedule({ adminData, branchID,financialYear }) {
   const searchInputRef = useRef(null);

  const location = useLocation();
  const mode = location.state?.mode;
  const partyId = location.state?.partyId;

  const editData = location.state?.data;

  const { setLoading } = useLoading();
  const [showForm, setShowForm] = useState(false);
  const [content, setContent] = useState("");

  const getCurrentDateTime = () => {
    const now = new Date();

    const istOffset = 5.5 * 60;
    const localOffset = now.getTimezoneOffset();
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

    const year = istTime.getFullYear();
    const month = String(istTime.getMonth() + 1).padStart(2, "0");
    const day = String(istTime.getDate()).padStart(2, "0");
    const hours = String(istTime.getHours()).padStart(2, "0");
    const minutes = String(istTime.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };


  const [formItems, setFormItems] = useState({
    service_type: '',
    ref_doc: '',
    party: '',
    party_add: '',
    party_phone: "",
    party_mobile: "",
    party_phone_two: "",
    party_phone_three: '',
    description: '',
    created_date: getCurrentDateTime(),
    status: '',
    source: '',
    remark: '',
    cost: '',
    items: [
      {
        item: null, install: "", sr_no: "",
        details: [

          {
            item: null,
            quantity: 1,
            sr_no: "",
            technician: null
          }
        ]

      }
    ],
    customer_remark: '',


    visits: [
      {
        technician: null,
        assignedDate: "",
        visitDate: "",
        visitOutDate: '',
        inLocation: "",
        outLocation: '',

        remark: "",
        status: null,
        status_type:'service'
      }
    ],
  })

  const [files, setFiles] = useState({
    file: null,

  })
  const [formData, setFormData] = useState([]);



  useEffect(() => {
      if (mode === "edit" && editData) {
          handleEdit(editData);   
      }
  }, [editData, mode]);

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const [search, setSearch] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [partyOptions, setPartyOptions] = useState([]);
  const [detail, setDetail] = useState([]);
  const [user, setUser] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [selectedParty, setSelectedParty] = useState("");
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);


  const [rows, setRows] = useState([]);
  const [isInitialEditLoad, setIsInitialEditLoad] = useState(false);
  const [branchDetail, setBranchDetail] = useState([])
  const [refDocs, setRefDocs] = useState([]);
  const [allSaleInvoices, setAllSaleInvoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
   const [previewRemark, setPreviewRemark] = useState("");
    const [showPreview, setShowPreview] = useState(false);


    
      const [offset, setOffset] = useState(0);
      const limit = 20;
      const [hasMore, setHasMore] = useState(true);
      const [fromDate, setFromDate] = useState();
      const [toDate, setToDate] = useState();
      const [isLocked, setIsLocked] = useState(false);
      const [fy, setFy] = useState([]);
    
      const [financialRange, setFinancialRange] = useState({
        from_date: '',
        to_date: ''
      });
    
    
  
  const [serviceOptions, setServiceOptions] = useState([
    { label: "PMS", value: "PMS" },
    { label: "CS", value: "CS" },
    { label: "Normal", value: "Normal" },
    { label: "Cartradge Chang", value: "Cartradge_Chang" },
  ]);

  const [selectedService, setSelectedService] = useState(null);

  const [showServiceModal, setShowServiceModal] = useState(false);
  const [newServiceName, setNewServiceName] = useState("");
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);

  const [statusOptions, setStatusOptions] = useState([
    { value: "APPOINTMENT", label: "APPOINTMENT" },
    { value: "Closed CMP", label: "Closed CMP" },
    { value: "COMPLETED OC", label: "COMPLETED OC" },
    { value: "FAILED", label: "FAILED" },
    { value: "IN FALLOWUP", label: "IN FALLOWUP" },
    { value: "OPEN CMP", label: "OPEN CMP" },
    { value: "Passed PMS", label: "Passed PMS" },
    { value: "RE-COMPLAINT", label: "RE-COMPLAINT" },
    { value: "VISIT", label: "VISIT" }
  ]);

  const [sourceOptions, setSourceOptions] = useState([
    { value: "Pending", label: "Pending" },
    { value: "In Progress", label: "In Progress" },
    { value: "Completed", label: "Completed" }
  ]);



  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailItems, setDetailItems] = useState([
    { item: null, quantity: "", sr_no: "", technician: null }
  ]);

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyItems, setHistoryItems] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const [editingPmsId, setEditingPmsId] = useState(null);
  const [fetchPms, setFetchPms] = useState([]);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [editingPms, setEditingPms] = useState(null);
  const [savedRemark, setSavedRemark] = useState("");
  const [newRemark, setNewRemark] = useState("");  
    const [addresses, setAddresses] = useState({});
    

useEffect(() => {
  if (showPartyModal) {
    setTimeout(() => {
      searchInputRef.current?.focus();
    }, 100);
  }
}, [showPartyModal]);

        useEffect(() => {
  if (!adminData.user.emp_id) return;

  socket.on("connect", () => {

    socket.emit("register-user", adminData.user.emp_id);
   
  });

  // If already connected
  if (socket.connected) {
    socket.emit("register-user", adminData.user.emp_id);

  }

  return () => {
    socket.off("connect");
  };
}, [adminData.user.emp_id]);



useEffect(() => {
  const handleMaterial = (data) => {
    showToast(data.message, "info");
  };

  socket.on("new-pms-call", handleMaterial);

  return () => {
    socket.off("new-pms-call", handleMaterial);
  };
}, []);


  // const filtered = partyOptions.filter(
  //   (p) =>
  //     p.label.toLowerCase().includes(search.toLowerCase()) ||
  //     (p.phone && p.phone.toLowerCase().includes(search.toLowerCase())) ||
  //     (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
  // );

const searchValue = (search || "").toLowerCase();

const filtered = partyOptions.filter((p) => {
  const labelMatch =
    p?.label?.toLowerCase().includes(searchValue);

  const phoneMatch =
    Array.isArray(p?.phoneList) &&
    p.phoneList.some(
      (ph) => ph?.toLowerCase().includes(searchValue)
    );

  const addressMatch =
    p?.address?.toLowerCase().includes(searchValue);

  return labelMatch || phoneMatch || addressMatch;
});

  const handleOpenHistory = () => {
    setShowHistoryModal(true);
    // fetchHistory();
  };

  const updateDetailRow = (index, field, value) => {
    const newDetailItems = [...detailItems];

    if (field === "item") {
      newDetailItems[index].item = value;
      newDetailItems[index].sr_no = value.sr_no;
      newDetailItems[index].quantity = 1;
    } else {
      newDetailItems[index][field] = value;
    }

    setDetailItems(newDetailItems);
  };


  // Add a new row
  const addDetailRow = () => {
    setDetailItems(prev => [...prev, { item: null, quantity: 1, sr_no: "", technician: null }]);
  };

  // Delete a row
  const deleteDetailRow = (index) => {
    setDetailItems(prev => prev.filter((_, i) => i !== index));
  };


  const addRow = () => {
    setFormItems(prev => ({
      ...prev,
      items: [...prev.items, { item: "", install: "" }]
    }));
  };

  const handleAddClick = () => {
    setShowForm(true);
  }


  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    const fieldName = e.target.name;


    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes → MB
      if (fileSizeInMB > 2) {
        setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
        return;
      }
      setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
    }



  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };




  const addVisitRow = () => {
    setFormItems(prev => ({
      ...prev,
      visits: [
        ...prev.visits,
       {
          technician: null,
          assignedDate: "",
          visitDate: "",
          visitOutDate: '',
          inLocation: "",
          outLocation: '',
          location: "",
          remark: "",
          status: null
        }
      ]
    }));
  };


  const deleteRow = (index) => {
    setFormItems(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };


  const updateVisitRow = (index, field, value) => {
    setFormItems(prev => {
      const updatedVisits = [...prev.visits];
      updatedVisits[index][field] = value;

      return {
        ...prev,
        visits: updatedVisits
      };
    });
  };


  const updateItemRow = (index, field, value) => {
    const updatedItems = [...formItems.items];
    updatedItems[index][field] = value;
    setFormItems(prev => ({
      ...prev,
      items: updatedItems
    }));
  };




  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const sendData = new FormData();
      const safe = (v) => (v === undefined || v === null ? "" : v);


      const basicFields = {
        service_type: safe(formItems.service_type),
        ref_doc: safe(formItems.ref_doc),
        party: safe(formItems.party),
        party_add: safe(formItems.party_add),
        party_phone: safe(formItems.party_phone),
        party_mobile: safe(formItems.party_mobile),
        party_phone_two: safe(formItems.party_phone_two),
        party_phone_three: safe(formItems.party_phone_three),
        description: safe(formItems.description),
        // remark: safe(formItems.remark),
        customer_remark: safe(formItems.customer_remark),
        source: safe(formItems.source),
        cost: safe(formItems.cost),
        status: safe(formItems.status),
        created_date: formItems.created_date ? formItems.created_date.replace("T", " ") : ""
      };


      Object.entries(basicFields).forEach(([key, value]) => {
        sendData.append(key, value);
      });

      if (newRemark?.trim()) {
  const remarkPayload = {
    remark: newRemark.trim(),
    adminId: adminData.user.id,
    date: new Date().toISOString()
  };

  sendData.append("remark", JSON.stringify(remarkPayload));
}

    const formattedItems = (formItems.items || []).map(item => ({
        item_id: item.item?.value ?? item.id ?? null,

        // ✅ FIXED item_name
        name:
          item.item?.label ??
          item.name ??
          null,

        install: item.install || "",
        sr_no: item.sr_no || [],

        details: (item.details || []).map(d => ({
          item_id: d.item?.value ?? d.id ?? null,
          name:
            d.item?.label ??
            d.name ??
            null,
          quantity: Number(d.quantity) || 1,
          sr_no: d.sr_no || "",
          technician_id: d.technician?.value || null
        }))
      }));



      sendData.append("items", JSON.stringify(formattedItems));

      // ===== VISITS =====
      const formattedVisits = (formItems.visits || []).map((v, idx) => {
        const visit = {
          technician_id: v.technician?.value || null,
          assignedDate: safe(v.assignedDate),
          visitDate: safe(v.visitDate),
          visitOutDate: safe(v.visitOutDate),
          inLocation: safe(v.inLocation),
          outLocation: safe(v.outLocation),
          remark: safe(v.remark),
          status: v.status,
          status_type:v.status_type || 'service',
        };
   
        return visit;
      });

      sendData.append("visits", JSON.stringify(formattedVisits));

      // ===== FILE =====
      if (files.file) {
      
        sendData.append("file", files.file);
      }


      let res;

      // ===== EDIT MODE =====
      if (isEditMode && editingPmsId) {
        sendData.append("edit_by", adminData.user.id);
    

        res = await axios.put(
          `https://api.skyguard.group/api/update-pms-schedule/${editingPmsId}`,
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("PMS Schedule Updated Successfully!", "success");

      }
      // ===== ADD MODE =====
      else {
        sendData.append("added_by", adminData.user.id);
     

        res = await axios.post(
          "https://api.skyguard.group/api/add-pms-schedule",
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("PMS Schedule Added Successfully!", "success");
      }

      resetForm();
      fetchPmsDetail(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);

    } catch (err) {
      console.error("❌ PMS Error:", err.response?.data || err.message);
      showToast(
        isEditMode ? "Failed to update PMS Schedule" : "Failed to add PMS Schedule",
        "danger"
      );
    }
  };


  const getAddressFromLatLng = async (lat, lng) => {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
    );
    const data = await res.json();

    if (!data || !data.address) return "";

    const {
      suburb,
      city,
      town,
      village,
      county,
      state,
      postcode
    } = data.address;


    const cityName = city || town || village || "";


    return [
      suburb,
      cityName,
      county,
      state,
      postcode
    ]
      .filter(Boolean)
      .join(", ");

  } catch (err) {
    console.error("Reverse geocode failed:", err);
    return "";
  }
};


const parseLatLng = (val) => {
  if (!val) return null;


  if (typeof val === "string" && val.startsWith("[")) {
    try {
      const arr = JSON.parse(val);
      if (
        Array.isArray(arr) &&
        arr.length === 2 &&
        !isNaN(arr[0]) &&
        !isNaN(arr[1])
      ) {
        return { lat: Number(arr[0]), lng: Number(arr[1]) };
      }
    } catch {
      return null;
    }
  }


  if (typeof val === "string" && val.includes(",")) {
    const [lat, lng] = val.split(",").map(v => Number(v.trim()));
    if (!isNaN(lat) && !isNaN(lng)) {
      return { lat, lng };
    }
  }

  return null;
};

const safeParseArray = (value) => {
  if (!value) return [];
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return Array.isArray(value) ? value : [];
};



const handleEdit = async (pms) => {


  if (!pms) return;

  setIsEditMode(true);
  setEditingPmsId(pms.id);
  setSavedRemark(pms.remark || "");
  setNewRemark("");

  /* ===================== ITEMS + DETAILS ===================== */

  const itemsArray = safeParseArray(pms.items);
  const techniciansArray = safeParseArray(pms.technicians);



  const parsedItems = itemsArray.map(item => {
    let combinedDetails = [];

    techniciansArray.forEach(tech => {
      const techDetails = safeParseArray(tech.item_details);

      const matching = techDetails
        .filter(d => Number(d.model_id) === Number(item.id))
        .map(d => ({
          ...d,
          technician_id: tech.technician_id
        }));

      combinedDetails.push(...matching);
    });

    return {
       item: {
    value: item.id,
    label: item.name
  },
      qty: item.qty || 1,
      install: item.install || "",
      sr_no: Array.isArray(item.sr_no)
  ? item.sr_no
  : item.sr_no
    ? [item.sr_no]
    : [],

      
      details: combinedDetails.map(d => ({
        item: d.item_id,
        item_name: d.name,
        quantity: d.qty || d.quantity || 1,
        sr_no: Array.isArray(d.sr_no) ? d.sr_no.join(", ") : d.sr_no || "",
        technician: d.technician_id
      }))
    };
  });


 

  /* ===================== VISITS ===================== */

   const editVisits = [];

if (Array.isArray(pms.technicians)) {
  const visitsWithAddress = await Promise.all(
    pms.technicians.map(async (t) => {
      let inLocation = t.inLocation || "";
      let outLocation = t.outLocation || "";



const inCoords = parseLatLng(inLocation);
if (inCoords) {
  inLocation = await getAddressFromLatLng(inCoords.lat, inCoords.lng);
}


const outCoords = parseLatLng(outLocation);
if (outCoords) {
  outLocation = await getAddressFromLatLng(outCoords.lat, outCoords.lng);
}

      return {
        id: t.id || null,
        technician:
          employeeOptions.find(e => e.value === t.technician_id) || {
            value: t.technician_id,
            label: t.technician_id
          },
        assignedDate: t.assignedDate || "",
        visitDate: t.visitDate || "",
        visitOutDate: t.visitOutDate || "",
        inLocation,
        outLocation,
        remark: t.remark || "",
       status:
    statusOptions.find(s =>
      String(s.value).toLowerCase() === String(t.status).toLowerCase() ||
      String(s.label).toLowerCase() === String(t.status).toLowerCase()
    ) || {
      value: t.status,
      label: t.status
    },
        status_type: t.status_type || "serivce"
      };
    })
  );

  editVisits.push(...visitsWithAddress);
}

  /* ===================== TECHNICIAN HISTORY ===================== */

  const historyItems = [];

  techniciansArray.forEach(tech => {
    const techDetails = safeParseArray(tech.item_details);

    techDetails.forEach(d => {
      historyItems.push({
        date: tech.visitDate || "",
        model_name: d.name || "",
        sub_item: d.name || "",
        quantity: d.qty || d.quantity || 1,
        technician: tech.technician_id,
        sr_no: Array.isArray(d.sr_no) ? d.sr_no.join(", ") : d.sr_no || ""
      });
    });
  });

  setHistoryItems(historyItems);


      const selectedServiceOption =
  serviceOptions.find(opt => opt.value === pms.service_type) ||
  { label: pms.service_type, value: pms.service_type };

setServiceOptions(prev => {
  const exists = prev.some(opt => opt.value === pms.service_type);
  return exists ? prev : [...prev, selectedServiceOption];
});

setSelectedService(selectedServiceOption);


  /* ===================== FORM STATE ===================== */

  setFormItems(prev => ({
    ...prev,
    id:pms.id,
    service_type: pms.service_type,
    ref_doc: pms.ref_doc,
    party: pms.party,
    partyName: pms.party_name || "",
    party_address: pms.party_address || "",
    party_phone: pms.party_phone || "",
    party_mobile: pms.party_mobile || "",
    description: pms.description || "",
    customer_remark: pms.customer_remark || "",
    source: pms.source || "",
    status: pms.status || "",
    cost: pms.cost ?? "",
    items: parsedItems,
    visits: editVisits,
    created_date:pms.created_date || "",
  }));

  setDetailItems(parsedItems[0]?.details || []);
  setFiles({ file: pms.attachment || null });
  setShowForm(true);
};



   const EMPTY_VISIT = {
  id: null,
  technician: null,
  assignedDate: "",
  visitDate: "",
  visitOutDate: "",
  inLocation: "",
  outLocation: "",
  remark: "",
  status: null
};

const INITIAL_FORM_DATA = {
  complaintType: "",
  party: "",
  site: "",
  contact_no: "",
  date: getCurrentDateTime(),
  franchisee_cost: "",
  description: "",
  remarks: "",
  source: "",
  customer_remark: "",
  status: "",
  items: [
    {
      item: null,
      install: "",
      sr_no: [],
      details: [
        {
          item: null,
          quantity: 1,
          sr_no: [],
          technician: null
        }
      ]
    }
  ],
  attachments: [],
  partyid: "",
  approval_status: "Pending",
  visits: [ { ...EMPTY_VISIT } ]
};


  
const resetForm = () => {
  setIsEditMode(false);
  setEditingPmsId(null);
  setShowForm(false);
  setNewRemark("");

  setFormItems({ ...INITIAL_FORM_DATA }); 

  setSelectedDoc(null);
  setSelectedParty(null);
  setSubTotal("0.00");
  setTotalTax("0.00");
  setGrandTotal("0.00");
  setFiles({});
  setContent("");
  setSelectedService(null);
};


const handleCancel = () => {
  resetForm();          
  setIsEditMode(false);  
  setEditingPmsId(null);
  setShowForm(false);   
};



  const fetchPartyDetail = async () => {
    try {
      const resParty = await axios.get("https://api.skyguard.group/api/fetch-party-bill");

      const options = resParty.data.map((p) => ({
        value: p.id,
        label: p.name,
        phone: p.phone,
        address: p.address,
        phone: p.phone || "",
        mobile: p.mobile || "",
        phone_two: p.phone_two || "",
        phone_three: p.phone_three || "",
      }));

      const data = resParty.data;

      setDetail(data);

      setPartyOptions(options);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchBranchDetail = async () => {
    setLoading(true)
    try {
      const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
      setBranchDetail(branchRes.data)

      return branchRes.data.code;
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

   const fetchYearDetail = async () => {
      setLoading(true);
      try {
        const branchCode = await fetchBranchDetail();
  
        const res = await axios.get(
          `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
        );
        const yearData = res.data;
        setFy(yearData);
        setIsLocked(yearData.is_locked === 1);
        setFinancialRange({
          from_date: yearData.from_date,
          to_date: yearData.to_date
        });
  
        await fetchPmsDetail(
          yearData.from_date,
          yearData.to_date,
          branchCode,
  
        );
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };


  const fetchInventoryDetail = async () => {
    setLoading(true)
    try {
      const resInventory = await axios.get("https://api.skyguard.group/api/fetch-inventory");
      const items = resInventory.data.result || [];

      const options = items.map(item => ({
        value: item.id,
        label: item.name,
        sr_no: item.sr_no,
        image: item.file,
      }));

      setInventoryOptions(options);
    } catch (error) {
      console.log(error);
    }finally {
      setLoading(false);
    }
  }

  const fetchEmpDetail = async () => {
    setLoading(true)
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
      const employees = resEmployee.data.result || [];

      const options = employees
       .filter(emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== "")
      .map(emp => ({
        value: emp.emp_id,
        label: `${emp.first} ${emp.middle || ""} ${emp.last} (${emp.emp_id})`
      }));

      setEmployeeOptions(options);

    } catch (error) {
      console.log(error);
    }finally {
      setLoading(false);
    }
  };




const fetchPmsDetail = async (fromDate,
    toDate,
    branchCode,
    newOffset = 0) => {
  setLoading(true);

    if (!branchCode) {
      console.log("Branch code missing");
      return;
    }

  try {
    const res = await axios.get(
      "https://api.skyguard.group/api/fetch-pms-schedules",
       {
          params: {
            from_date: fromDate,
            to_date: toDate,
            branchId: branchCode,
            limit: limit,
            offset: newOffset
          }
        }
    );
  
  
 const parsedData = res.data
      .filter(row => row.status.toLowerCase() !== "completed oc")
      .map(row => ({
        ...row,
        items:
          typeof row.items === "string"
            ? JSON.parse(row.items)
            : row.items || [],
        remark_history:
          typeof row.remark_history === "string"
            ? JSON.parse(row.remark_history)
            : row.remark_history || []
      }));
   
    // setFetchPms(parsedData);
  const result = parsedData;
      if (newOffset === 0) {
       setFetchPms(result);
        setHasMore(true);
      }

      else {
       setFetchPms(prev => {
          const merged = [...prev, ...result];

          // optional: remove duplicates (safety)
          const unique = Array.from(
            new Map(merged.map(item => [item.id, item])).values()
          );

          return unique;
        });
      }

      if (result.length < limit) {
        setHasMore(false);
      }
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};



  useEffect(() => {

    fetchInventoryDetail();
    fetchPartyDetail();
    fetchEmpDetail();
    // fetchPmsDetail();
    fetchBranchDetail();
     fetchYearDetail();
  }, []);

  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };

  const filteredData = fetchPms.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );





const remarkTableData = fetchPms
  .filter(pms => pms.id === editingPmsId) 
  .flatMap(pms =>
    (pms.remark_history || []).map(r => ({
      adminId: r.adminId,
      adminName: r.adminName || "Unknown",
      remark: r.remark,
      date: r.date,
      pmsId: pms.id
    }))
  );

 const handleLoadMore = () => {

    const nextOffset = offset + limit;
    setOffset(nextOffset);

    fetchPmsDetail(
      financialRange.from_date,
      financialRange.to_date,
      branchDetail.code,
      nextOffset
    );
  };



  return (
    <>
      <div className='main-section'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />

        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <h3 className='my-3 fw-bold fs-5 golos'>PMS</h3>
          <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
            <div class="col-12 col-md-4">
              <input
                type="text"
                class="form-control"
                id="searchInput"
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-end">
              <button className='btn btn-success' onClick={handleAddClick} >
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>

          {showForm && (
            <form onSubmit={handleUpdate}>


              <div className="card p-3 my-3 shadow-sm bg-white border">
                <div className="row">

                  {/* LEFT SIDE */}
                  {/* LEFT SIDE */}
                  <div className="col-12 col-lg-4">

                                                                                                 {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
      {`PMS/${formItems.id}/${branchDetail.code}`}
    </span>
  </div>
)}
                    <div className="row g-3">

                      <div className="col-12">
                        <label className="form-label fw-medium">Service Type</label>

                        <Select
                          className="w-100"
                          value={selectedService}
                          options={[
                            ...serviceOptions,
                            { label: "➕ Add New Service", value: "__add_new_service__" }
                          ]}
                          onChange={(selected) => {
                            if (selected.value === "__add_new_service__") {
                              setShowServiceModal(true);
                              return;
                            }

                            setSelectedService(selected);

                            setFormItems(prev => ({
                              ...prev,
                              service_type: selected.value
                            }));
                          }}
                        />
                      </div>


                      {showServiceModal && (
                        <div className="modal show d-block" tabIndex="-1">
                          <div className="modal-dialog">
                            <div className="modal-content">

                              <div className="modal-header">
                                <h5 className="modal-title">Add New Service Type</h5>
                                <button
                                  className="btn-close"
                                  onClick={() => setShowServiceModal(false)}
                                />
                              </div>

                              <div className="modal-body">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter service type"
                                  value={newServiceName}
                                  onChange={(e) => setNewServiceName(e.target.value)}
                                />
                              </div>

                              <div className="modal-footer">
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    setShowServiceModal(false);
                                    setNewServiceName("");
                                  }}
                                >
                                  Cancel
                                </button>

                                <button
                                  className="btn btn-success"
                                  onClick={() => {
                                    if (!newServiceName.trim()) return;

                                    const newOption = {
                                      label: newServiceName,
                                      value: newServiceName
                                    };

                                    setServiceOptions(prev => [...prev, newOption]);
                                    setSelectedService(newOption);

                                    setFormItems(prev => ({
                                      ...prev,
                                      service_type: newServiceName
                                    }));

                                    setNewServiceName("");
                                    setShowServiceModal(false);
                                  }}
                                >
                                  OK
                                </button>
                              </div>

                            </div>
                          </div>
                        </div>
                      )}


                      <div className="col-12">
                        <label className="form-label fw-medium"> Party</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formItems.partyName || ""}
                          readOnly
                          onClick={() => setShowPartyModal(true)}
                        />

                        <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                          <Modal.Header closeButton>
                            <Modal.Title>Search Party</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form.Control
                              type="text"
                              placeholder="Search by name, phone, or address"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                                ref={searchInputRef}
                            />
                            <div className="table-responsive mt-3">
                              <Table striped bordered hover className="mt-3">
                                <thead>
                                  <tr>
                                     <th>Action</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                                   
                                  </tr>
                                </thead>
                                <tbody>
                                  {filtered.map((p) => (
                                    <tr key={p.value}>
                                          <td className="text-center" style={{ width: "80px" }}>

                                        <Button
                                          variant="primary"
                                          size="sm"
                                          onClick={() => {

                                            setFormItems((prev) => ({
                                              ...prev,
                                              party: p.value,
                                              partyName: p.label,
                                              party_add: p.address || "",
                                              // 🔹 store individually
                                              party_phone: p.phone || "",
                                              party_mobile: p.mobile || "",
                                              party_phone_two: p.phone_two || "",
                                              party_phone_three: p.phone_three || ""
                                            }));
                                            setShowPartyModal(false);
                                          }}
                                        >
                                          Select
                                        </Button>

                                      </td>
                                      <td>{p.label}</td>
                                      <td>{p.phone}</td>
                                      <td style={{ maxWidth: "300px", whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {(p.address || "").length > 50 ? `${(p.address || "").slice(0, 50)}...` : (p.address || "NA")}
                                      </td>
                                  
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>

                          </Modal.Body>
                        </Modal>
                      </div>

                      <div className="col-12">
                        <label className="form-label fw-medium">Address</label>
                        <input
                          type="text"
                          name='party_address'
                          className="form-control"
                          value={formItems.party_address || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12">
                        <label className="form-label fw-medium">Select Status</label>
                        <Select
                          options={statusOptions}
                          value={
                            statusOptions.find(
                              opt => opt.value.toLowerCase() === String(formItems.status || "").toLowerCase()
                            ) || null
                          }
                          onChange={(selected) =>
                            setFormItems({ ...formItems, status: selected.value })
                          }
                        />
                      </div>




                    </div>
                  </div>



                  {/* RIGHT SIDE */}
                  <div className="col-12 col-lg-8">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label fw-medium">Ref Doc</label>
                        <Select
                          placeholder="Choose Ref Doc..."
                          options={[{ value: formItems.ref_doc, label: formItems.ref_doc }]} // single option
                          value={formItems.ref_doc ? { value: formItems.ref_doc, label: formItems.ref_doc } : null}
                          isDisabled={isEditMode}
                          onChange={(selected) =>
                            setFormItems({ ...formItems, ref_doc: selected.value })
                          }
                        />

                      </div>


                      <div className="col-md-6">
                        <label className="form-label fw-medium">Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={formItems.created_date}
                          onChange={handleChange}
                        />
                      </div>



                      <div className="col-md-6">
                        <label className="form-label fw-medium">Contact Number</label>
                        <input
                          type="text"
                          className="form-control"
                          value={[
                            formItems?.party_phone,
                            formItems?.party_mobile,
                            formItems?.party_phone_two,
                            formItems?.party_phone_three
                          ].filter(Boolean).join(", ") || ""}
                          readOnly
                        />

                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-medium">Franchisee Cost</label>
                        <input
                          type="number"
                          className="form-control"
                          name='cost'
                          value={formItems.cost}
                          onChange={handleChange}
                        />
                      </div>


                      <div className="col-md-12">
                        <label className="form-label fw-medium">Description</label>
                        <textarea
                          className="form-control"
                          rows="5"
                          name='description'
                          value={formItems.description}
                          onChange={handleChange}
                        />
                      </div>

                    </div>
                  </div>
                   
                      <div className='col-12 mt-3' >
                           <div className="d-flex justify-content-end mb-2">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm col-md-1"
                        onClick={() => {
                          setFormItems(prev => ({
                            ...prev,
                            items: [...prev.items, { item: "", install: "" }]
                          }));
                        }}
                      >
                        + Add Item
                      </button>
                    </div>
                     <div className="table-responsive">
                               <table className="table table-bordered mx-auto text-center align-middle  w-75">
                      <thead className="table-primary">
                        <tr>
                          <th>Model</th>
                          <th>Installed In</th>
                          <th>Sr No </th>
                          <th>Details</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(formItems.items || []).map((row, index) => (
                          <tr key={index}>
                            <td style={{ minWidth: "250px" }}>
                              <Select
                                options={inventoryOptions}
                                value={row.item}   
                                onChange={(selected) => updateItemRow(index, "item", selected)}
                                 menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: "100%" }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                              />

                            </td>

                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={row.install}
                                onChange={(e) => updateItemRow(index, "install", e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={row.sr_no?.length ? row.sr_no.join(", ") : ""}
                                readOnly
                                className="form-control"
                              />
                            </td>

                            <td>


                              <button
  type="button"
  className="btn btn-success btn-sm m-1"
  onClick={() => {
    setSelectedItemIndex(index);
    setDetailItems(row.details);
    setShowDetailModal(true);
  }}
>
  Detail
</button>


                              <button
                                type="button"
                                className="btn btn-primary btn-sm m-1"
                                onClick={handleOpenHistory}
                              >
                                History
                              </button>

                              <button
                                type="button"
                                className="btn btn-secondary btn-sm m-1"
                                onClick={() => {
                                  if (row.item && row.item.image) {
                                    let imagesArray = [];
                                    try {
                                      imagesArray = JSON.parse(row.item.image);
                                    } catch (err) {
                                      console.error("Error parsing image JSON:", err);
                                    }

                                    if (imagesArray.length > 0) {
                                      setSelectedImage(imagesArray);
                                      setShowImageModal(true);
                                    } else {
                                      alert("No image available for this item");
                                    }
                                  } else {
                                    alert("No image available for this item");
                                  }
                                }}
                              >
                                View Image
                              </button>
                            </td>

                            <td>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => {
                                  const newItems = (formItems.items || []).filter((_, i) => i !== index);
                                  setFormItems(prev => ({ ...prev, items: newItems }));
                                }}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}

                      </tbody>
                    </table>
                     </div>
                     

                      </div>
                   
           
           

                  <div className='row' >
                    <div className="col-12 col-lg-4">
                      <div className="row g-3">

                        <div className="col-12">
                          <label className="form-label fw-medium">Select Source</label>
                          <Select
                            options={sourceOptions}
                            value={
                              sourceOptions.find(
                                opt => opt.value.toLowerCase() === String(formItems.source || "").toLowerCase()
                              ) || null
                            }
                            onChange={(selected) =>
                              setFormItems({ ...formItems, source: selected.value })
                            }
                          />

                        </div>

                        <div className='col-12 '>
                          <label className='form-label fw-medium'>Attachment</label>
                          <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange} />
                          {isEditMode && files.file && typeof files.file === "string" && (
                            <div className="mt-2">
                              <span>Previous file: </span>
                              <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                            </div>
                          )}
                        </div>


                      </div>
                    </div>


                    <div className="col-12 col-lg-8">
                      <div className="row g-3">
                        <div className='col-12'>
                          <label htmlFor='remark' className="form-label fw-medium"> Remark</label>
                          <textarea
                            className="form-control"
                            name="remark"
                            placeholder="Enter here..."
                            rows="6"
                            value={newRemark}
                            onChange={(e) => setNewRemark(e.target.value)}
                          />
                        </div>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mt-3">

                    <div className="d-flex justify-content-end mb-2">
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={addVisitRow}
                      >
                        + Add Visit
                      </button>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle w-100 " >
                        <thead className="table-dark">
                          <tr>
                            <th>Technician Name</th>
                           <th>Assigned Date Time</th>
                              <th>Visit Date Time</th>
                              <th>Visit Out Date Time</th>
                              <th>In Location</th>
                              <th>Out Location</th>
                              <th>Remark</th>
                              <th>Status</th>
                          </tr>
                        </thead>

                        <tbody key={editingPmsId || null}>
                          {formItems?.visits?.map((row, index) => (
                            <tr key={index}>
                              <td className="col-2">
                                <Select
                                  menuPortalTarget={document.body}
                                  styles={{ container: base => ({ ...base, width: "100%" }) }}
                                  options={employeeOptions}
                                  value={row.technician || null}
                                  onChange={(selected) =>
                                    updateVisitRow(index, "technician", selected)
                                  }
                                />
                              </td>

                              <td className="col-2">
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  value={row.assignedDate}
                                  onChange={e => updateVisitRow(index, "assignedDate", e.target.value)}
                                />
                              </td>

                              <td className="col-2">
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  value={row.visitDate}
                                  onChange={e => updateVisitRow(index, "visitDate", e.target.value)}
                                />
                              </td>
 <td className="col-2">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={row.visitOutDate}
                                    onChange={e => updateVisitRow(index, "visitOutDate", e.target.value)}
                                  />
                                </td>

                                <td className="col-2">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={row.inLocation}
                                    onChange={e => updateVisitRow(index, "inLocation", e.target.value)}
                                  />
                                </td>
                                <td className="col-2">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={row.outLocation}
                                    onChange={e => updateVisitRow(index, "outLocation", e.target.value)}
                                  />
                                </td>

                                 <td className="col-2">
                                  <div className="d-flex gap-2">
                                    {/* <input
                                   type="text"
                                      className="form-control"
                                      value={row.remark}
                                     onChange={e => updateVisitRow(index, "remark", e.target.value)}
                                      /> */}

                                    <button
                                      type="button"
                                      className="btn btn-sm btn-primary"
                                      onClick={() => {
                                        setPreviewRemark(row.remark);
                                        setShowPreview(true);
                                      }}
                                    >
                                      Preview
                                    </button>
                                  </div>
                                </td>

                                <td className="col-2" >
                                  <div style={{ minWidth: 150 }}>
                                    <Select
                                      options={statusOptions}
                                      value={row.status}
                                      onChange={val => updateVisitRow(index, "status", val)}
                                      styles={{
                                        container: base => ({ ...base, width: "100%" }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                      }}
                                      menuPortalTarget={document.body}
                                      isDisabled={row.status?.value === "RE-COMPLAINT"}
                                    />
                                  </div>

                                </td>
                            </tr>
                          ))}
                        </tbody>


                      </table>
                    </div>
                  </div>


                  <div className='col-12'>
                    <label htmlFor='remark' className="form-label fw-medium">Remarks/Customer Feedback</label>
                    <textarea
                      className="form-control"
                      name="customer_remark"
                      id="remarks"
                      placeholder="Enter here..."
                      rows="6"
                      value={formItems.customer_remark}
                      onChange={(e) =>
                        setFormItems({ ...formItems, customer_remark: e.target.value })
                      }
                    />
                  </div>
                  <div className='col-12 mt-3' >
                    <h3 className='text-'>Remark History </h3>
                    <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle w-100 " >
                        <thead className="table-info">
                          <tr>
                            <th scope='col'>Employee Name</th>
                            <th scope='col'>Remark Date </th>

                            <th scope='col'>Remark</th>


                          </tr>
                        </thead>
                        <tbody>
    {remarkTableData.length > 0 ? (
      remarkTableData.map((row, index) => (
        <tr key={index}>
          <td>{row.adminName} </td>

          <td>
            {row.date
              ? new Date(row.date).toLocaleString()
              : "-"}
          </td>

          <td className="text-start">
            {row.remark}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="3" className="text-muted">
          No remark history found
        </td>
      </tr>
    )}
  </tbody>
                      </table>
                    </div>

                  </div>

                  
                  <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                    <button type="submit" className='btn btn-success'>{isEditMode ? "Update" : "Save"}</button>
                  <button
  type='button'
  className='btn btn-danger'
  onClick={handleCancel}
>
  Cancel
</button>

                  </div>
                </div>
              </div>



            </form>
          )}


          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>
              <thead className='table-info'>
                <tr>
                  <th>SN</th>
    <th scope='col' >Action</th>
                  <th scope='col' >Doc No. </th>
                 
                  <th scope='col'>Party Name</th>

                  <th scope='col'>Added By</th>
                  <th scope='col'>Added Date</th>

                  <th scope='col'>Edit By</th>

                  <th scope='col'>Edit Date</th>
               
                </tr>
              </thead>
              <tbody>
                {filteredData.map((p, i) => (
                  <tr key={p.id}>
                    <td>{filteredData.length - i }</td>
                
                          <td>

                      <button
                        className="btn btn-success"

                        onClick={() => handleEdit(p)}
                      >
                        <CiEdit size={20} />
                      </button>
                    </td>

                        <td>{`PMS/${p.id}/${branchDetail.code}/${fy.financial_year.split('-')[0]}`}</td>

                    <td>{p.party_name}</td>
                    <td>{p.added_name} {p.added_name_middle} {p.added_name_last} </td>
                    <td>{formatDateTime(p.created_date)}  </td>

                    <td>{p.edit_name} {p.edit_name_middle} {p.edit_name_last} </td>
                    <td>{p.edit_date} </td>

              
                  </tr>
                ))}
              </tbody>

            </table>
          </div>

            {/* item detail  */}
              <Modal
                show={showDetailModal}
                onHide={() => setShowDetailModal(false)}
                size="lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Item Details</Modal.Title>
        
        
        
                </Modal.Header>
        
                <Modal.Body>
        
                  <div className="d-flex justify-content-start mb-2">
                  
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered text-center align-middle" style={{ tableLayout: "fixed" }}>
                      <thead className="table-dark">
                        <tr>
        
                          <th>Item Name</th>
                          <th>Quantity</th>
                          <th>Sr No</th>
                          <th>Technician</th>
                   
                        </tr>
                      </thead>
                    <tbody>
          {detailItems.map((row, index) => (
            <tr key={index}>
              <td>{row.item_name}</td>
              <td>{row.quantity}</td>
              <td>{Array.isArray(row.sr_no) ? row.sr_no.join(", ") : row.sr_no}</td>
              <td>{row.technician || "-"}</td>
             
            </tr>
          ))}
        </tbody>
        
                    </table>
                  </div>
        
        
                </Modal.Body>
        
                <Modal.Footer>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowDetailModal(false)}
                  >
                    Close
                  </button>
        
                
        
                </Modal.Footer>
              </Modal>
        
        
        {/* techinician history*/}
              <Modal
                show={showHistoryModal}
                onHide={() => setShowHistoryModal(false)}
                size="lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Technician History</Modal.Title>
                </Modal.Header>
        
                <Modal.Body>
                  {loadingHistory ? (
                    <div className="text-center">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle">
                        <thead className="table-dark">
                          <tr>
                            <th>Model Name</th>
                            <th>Tehnician</th>
                            <th>Done On</th>
                          
                 
                            <th>Sub Part </th>
                            <th>Qty </th>
                            <th>Sr No</th>
                           
                          </tr>
                        </thead>
                        <tbody>
                          {historyItems.length === 0 ? (
                            <tr>
                              <td colSpan="5">No history found</td>
                            </tr>
                          ) : (
                            historyItems.map((row, index) => (
                              <tr key={index}>
          <td>{row.model_name}</td>
          <td>{row.technician}</td>
          <td>{row.date}</td>
          <td>{row.sub_item} </td>
          <td>{row.quantity}</td>
          <td>{row.sr_no}</td>
        </tr>
        
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </Modal.Body>
        
                <Modal.Footer>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowHistoryModal(false)}
                  >
                    Close
                  </button>
                </Modal.Footer>
              </Modal>

          <Modal
            show={showImageModal}
            onHide={() => setShowImageModal(false)}
            size="md"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Item Images</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              {selectedImage && selectedImage.length > 0 ? (
                selectedImage.map((img, index) => (
                  <img
                    key={index}
                    src={`https://api.skyguard.group/uploads/${img}`} 
                    alt={`Item ${index + 1}`}
                    className="img-fluid my-2"
                    style={{ maxHeight: "300px" }}
                  />
                ))
              ) : (
                <p>No image available</p>
              )}
            </Modal.Body>

            <Modal.Footer>
              <button
                className="btn btn-secondary"
                onClick={() => setShowImageModal(false)}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>

  {showPreview && (
        <div className="modal show d-block mt-8" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Remark Preview</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPreview(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>{previewRemark || "No remark entered"}</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowPreview(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


   {hasMore && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-primary"
                  onClick={handleLoadMore}
                >
                  Load More
                </button>
              </div>
            )}

        </div>
      </div>
    </>
  )
}

export default ServiceSchedule


